import TEXT_EN from './Text-EN.json';

export const getI18NText = (textKey) => {
  if (TEXT_EN[textKey]) {
    return TEXT_EN[textKey]
  } else {
    throw new Error(`Given ${textKey} is missing`);
  }
};
